import { PaymentStateModel } from './models';

export const getOrderStatus = (state: PaymentStateModel) => {
  return state.orderStatus;
};

export const getReceiptUrl = (state: PaymentStateModel) => {
  return state.receiptUrl;
};
